import { render } from "./BaseTextInput.vue?vue&type=template&id=5d853aac"
import script from "./BaseTextInput.vue?vue&type=script&lang=ts"
export * from "./BaseTextInput.vue?vue&type=script&lang=ts"

import "./BaseTextInput.vue?vue&type=style&index=0&id=5d853aac&lang=scss"
script.render = render

export default script